import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Location",
  "use": "Location-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"Location\"><path d=\"M10.422 19.996a.412.412 0 0 0 .37-.231L19.962.595a.466.466 0 0 0-.07-.486.466.466 0 0 0-.486-.07L.235 9.207c-.162.07-.255.278-.231.463a.445.445 0 0 0 .416.325h9.585v9.585c0 .185.14.37.325.416h.092z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol